export default {
  data() {
    return {
      dataFrom: {
        // premium:''
      },
      dialogVisible: false
    };
  },
  computed: {
    dataRule() {
      return {
        premium: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('分保费累计')
        }],
        premium2: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('应付保费累计')
        }],
        premium3: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('分保佣金累计')
        }],
        premium4: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('分保费累计')
        }],
        premium5: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('应付保费累计')
        }],
        premium6: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('分保佣金累计')
        }]
      };
    }
  },
  methods: {
    init() {
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let arr = [{
            organizationName: '泛华保险服务集团',
            type: '临时分保',
            premium: this.dataFrom.premium,
            premium2: this.dataFrom.premium2,
            premium3: this.dataFrom.premium3,
            id: String(Math.random())
          }, {
            organizationName: '泛华保险服务集团',
            type: '合同分保',
            premium: this.dataFrom.premium4,
            premium2: this.dataFrom.premium5,
            premium3: this.dataFrom.premium6,
            id: String(Math.random())
          }];
          this.$emit('cancel');
          this.$emit('ok', arr);
        }
      });
    },
    premiumChange() {
      this.dataFrom.premium8 = Number(this.dataFrom.premium || 0) + Number(this.dataFrom.premium4 || 0);
    },
    premiumChange2() {
      this.dataFrom.premium9 = Number(this.dataFrom.premium2 || 0) + Number(this.dataFrom.premium5 || 0);
    },
    premiumChange3() {
      this.dataFrom.premium10 = Number(this.dataFrom.premium3 || 0) + Number(this.dataFrom.premium6 || 0);
    }
  }
};